import React from 'react';
import '../../stylesheets/pages/links.css';
import './style.css';

import Logo from '../../assets/images/logo-chequer.png';
import Slogan from '../../assets/images/bgvendas.png';

import { toast } from 'react-toastify';

// import {AuthContext} from '../../contexts/auth';
import AuthContext from '../../contexts/auth';
import {GlobalContext} from '../../contexts/global';

export default function Links(){

    const { login } = React.useContext(AuthContext);
    const { buttonName, valid, setButtonName, setValid } = React.useContext(GlobalContext);

    React.useEffect(()=>{
        setButtonName("Entrar")
    },[setButtonName]);

    const [email, setEmail] = React.useState("");
    const [password, setPassword] = React.useState("");    
    const [required, setRequired] = React.useState(false);

    const state = {
        email: setEmail,
        password: setPassword,
    }

    function stateChange(e){
        const name = e.target.name;
        const value = e.target.value;
        state[name](value);        
    }

    function Svg(props) {
        var useTag = `<use xlink:href="/images/sprite.svg#${props.icon}" />`;
        return <svg className={props.class} dangerouslySetInnerHTML={{__html: useTag }} />;
    }

    function validMessage(msg){
        setValid("not-valid");
        setRequired(true);
        toast.error(msg)
    }

    function handleSubmit(e){         
        e.preventDefault();         
        if(email.trim() === "") return validMessage("Informe seu email..");       
        if(password.trim() === "") return validMessage("Informe sua senha..");   
        setValid("is-valid");        
        setTimeout(() => {
            login(email, password);
        }, 200);         
    }

    const abrirWhatsApp = (vendedor) => {
        const mensagem = encodeURIComponent(
        `Olá ${vendedor.nome}! Vim pelo Instagram da Chequer Eletrodomésticos e gostaria de mais informações.`
        );

        window.open(
        `https://wa.me/${vendedor.telefone}?text=${mensagem}`,
        "_blank"
        );
    };

    //not-valid

    const vendedores = [
        {
            nome: "Flavinho",
            telefone: "5522998485605",
        },
        {
            nome: "Ferreira",
            telefone: "5522992564031",
        },
        {
            nome: "Nelson",
            telefone: "5522999496481",
        },
        {
            nome: "Rafael",
            telefone: "5522999866918",
        },
    ];

    return(
        <>
            <main
            className="pagina"
            style={{
                backgroundImage: `url(${Slogan})`,
            }}
            >
            <div className="links">
                {vendedores.map((vendedor, index) => (
                <button
                    key={index}
                    className="vendedor"
                    onClick={() => abrirWhatsApp(vendedor)}
                    aria-label={`Falar com ${vendedor.nome} pelo WhatsApp`}
                >
                    <span className="nome">{vendedor.nome}</span>

                    <span className="whatsapp">
                    Falar no WhatsApp
                    </span>
                </button>
                ))}
            </div>
            </main>
        </>
    )
}